/* tslint:disable */
/* eslint-disable */
/**
 * K2B
 * The K2B API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AirSzzPointPollutant } from '../models';
import { CreateAirSzzPointPollutantDto } from '../models';
import { UpdateAirSzzPointPollutantDto } from '../models';
import { getFromStorage } from '../../app/helpers';
/**
 * AirSzzPointPollutantsApi - axios parameter creator
 * @export
 */
export const AirSzzPointPollutantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAirSzzPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airSzzPointPollutantsControllerCreate: async (body: CreateAirSzzPointPollutantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling airSzzPointPollutantsControllerCreate.');
            }
            const localVarPath = `/air-szz-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airSzzPointPollutantsControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/air-szz-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airSzzPointPollutantsControllerFindByPointId: async (pointId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pointId' is not null or undefined
            if (pointId === null || pointId === undefined) {
                throw new RequiredError('pointId','Required parameter pointId was null or undefined when calling airSzzPointPollutantsControllerFindByPointId.');
            }
            const localVarPath = `/air-szz-point-pollutants/point/{pointId}`
                .replace(`{${"pointId"}}`, encodeURIComponent(String(pointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airSzzPointPollutantsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling airSzzPointPollutantsControllerFindOne.');
            }
            const localVarPath = `/air-szz-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airSzzPointPollutantsControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling airSzzPointPollutantsControllerRemove.');
            }
            const localVarPath = `/air-szz-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAirSzzPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airSzzPointPollutantsControllerUpdate: async (body: UpdateAirSzzPointPollutantDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling airSzzPointPollutantsControllerUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling airSzzPointPollutantsControllerUpdate.');
            }
            const localVarPath = `/air-szz-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AirSzzPointPollutantsApi - functional programming interface
 * @export
 */
export const AirSzzPointPollutantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAirSzzPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerCreate(body: CreateAirSzzPointPollutantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AirSzzPointPollutant>>> {
            const localVarAxiosArgs = await AirSzzPointPollutantsApiAxiosParamCreator(configuration).airSzzPointPollutantsControllerCreate(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<AirSzzPointPollutant>>>> {
            const localVarAxiosArgs = await AirSzzPointPollutantsApiAxiosParamCreator(configuration).airSzzPointPollutantsControllerFindAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<AirSzzPointPollutant>>>> {
            const localVarAxiosArgs = await AirSzzPointPollutantsApiAxiosParamCreator(configuration).airSzzPointPollutantsControllerFindByPointId(pointId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AirSzzPointPollutant>>> {
            const localVarAxiosArgs = await AirSzzPointPollutantsApiAxiosParamCreator(configuration).airSzzPointPollutantsControllerFindOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AirSzzPointPollutant>>> {
            const localVarAxiosArgs = await AirSzzPointPollutantsApiAxiosParamCreator(configuration).airSzzPointPollutantsControllerRemove(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {UpdateAirSzzPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerUpdate(body: UpdateAirSzzPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AirSzzPointPollutant>>> {
            const localVarAxiosArgs = await AirSzzPointPollutantsApiAxiosParamCreator(configuration).airSzzPointPollutantsControllerUpdate(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AirSzzPointPollutantsApi - factory interface
 * @export
 */
export const AirSzzPointPollutantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {CreateAirSzzPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerCreate(body: CreateAirSzzPointPollutantDto, options?: AxiosRequestConfig): Promise<AxiosResponse<AirSzzPointPollutant>> {
            return AirSzzPointPollutantsApiFp(configuration).airSzzPointPollutantsControllerCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<AirSzzPointPollutant>>> {
            return AirSzzPointPollutantsApiFp(configuration).airSzzPointPollutantsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<AirSzzPointPollutant>>> {
            return AirSzzPointPollutantsApiFp(configuration).airSzzPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<AirSzzPointPollutant>> {
            return AirSzzPointPollutantsApiFp(configuration).airSzzPointPollutantsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<AirSzzPointPollutant>> {
            return AirSzzPointPollutantsApiFp(configuration).airSzzPointPollutantsControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAirSzzPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airSzzPointPollutantsControllerUpdate(body: UpdateAirSzzPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<AirSzzPointPollutant>> {
            return AirSzzPointPollutantsApiFp(configuration).airSzzPointPollutantsControllerUpdate(body, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AirSzzPointPollutantsApi - object-oriented interface
 * @export
 * @class AirSzzPointPollutantsApi
 * @extends {BaseAPI}
 */
export class AirSzzPointPollutantsApi extends BaseAPI {
    /**
     * 
     * @param {CreateAirSzzPointPollutantDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirSzzPointPollutantsApi
     */
    public async airSzzPointPollutantsControllerCreate(body: CreateAirSzzPointPollutantDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<AirSzzPointPollutant>> {
        return AirSzzPointPollutantsApiFp(this.configuration).airSzzPointPollutantsControllerCreate(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirSzzPointPollutantsApi
     */
    public async airSzzPointPollutantsControllerFindAll(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<AirSzzPointPollutant>>> {
        return AirSzzPointPollutantsApiFp(this.configuration).airSzzPointPollutantsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} pointId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirSzzPointPollutantsApi
     */
    public async airSzzPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<AirSzzPointPollutant>>> {
        return AirSzzPointPollutantsApiFp(this.configuration).airSzzPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirSzzPointPollutantsApi
     */
    public async airSzzPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<AirSzzPointPollutant>> {
        return AirSzzPointPollutantsApiFp(this.configuration).airSzzPointPollutantsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirSzzPointPollutantsApi
     */
    public async airSzzPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<AirSzzPointPollutant>> {
        return AirSzzPointPollutantsApiFp(this.configuration).airSzzPointPollutantsControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {UpdateAirSzzPointPollutantDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirSzzPointPollutantsApi
     */
    public async airSzzPointPollutantsControllerUpdate(body: UpdateAirSzzPointPollutantDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<AirSzzPointPollutant>> {
        return AirSzzPointPollutantsApiFp(this.configuration).airSzzPointPollutantsControllerUpdate(body, id, options).then((request) => request(this.axios, this.basePath));
    }
}
